import { Navigate } from 'react-router';

import { useFirstPartnerApplicationsByPerson } from '~domains/partner-application/entities/application';
import { useCheckPartnerSelfie } from '~domains/profile/entities/documents';

import { ROUTES } from '~shared/config/routes';
import { ErrorScreen } from '~shared/ui/error-screen';
import { Loader } from '~shared/ui/loader';

export const PartnerRedirect = () => {
  const selfieQuery = useCheckPartnerSelfie();

  const applicationQuery = useFirstPartnerApplicationsByPerson({
    enabled: !!selfieQuery?.data?.clientPortraitExists,
  });

  if (selfieQuery.isLoading) {
    return <Loader />;
  }

  if (selfieQuery.isError || !selfieQuery.data) {
    return <ErrorScreen message="Failed to check profile state." />;
  }

  if (!selfieQuery.data.clientPortraitExists) {
    return <Navigate to={ROUTES.partner.profile} replace />;
  }

  if (applicationQuery.isLoading) {
    return <Loader />;
  }

  if (applicationQuery.isError) {
    return <ErrorScreen message="Failed to load applications." />;
  }

  if (applicationQuery.data) {
    const { applicationId, status } = applicationQuery.data;

    if (status === 'NEW') {
      return (
        <Navigate
          to={ROUTES.partner.applicationEdit.link(applicationId)}
          replace
        />
      );
    }

    return <Navigate to={ROUTES.partner.applicationMenu} replace />;
  }

  return <Navigate to={ROUTES.partner.application} replace />;
};
